<template>
  <vx-card>
    <h3> Extend NFCRead Mobile SDK Key </h3>
    <form-wizard color="rgba(var(--vs-primary), 1)" errorColor="rgba(var(--vs-danger), 1)" :title="null"
      :subtitle="null" finishButtonText="Submit" ref="checkoutWizard">
      <tab-content title="PLATFORM" class="mb-5" icon="feather icon-home" :before-change="validateStep1">
        <!-- tab 1 content -->
        <form data-vv-scope="step-1">
          <div class="vx-row">
            <vs-col vs-w="12">

              <h2 class="text-center mt-10 mb-3">Which platform do you want to extend?</h2>
            </vs-col>
            <div class="vx-col md:w-1/2 w-full mt-5 mx-auto">

              <v-select :filter="fuseSearch" data-vv-validate-on="blur" placeholder="Select your platform *"
                name="platform_name" v-model="selectedPlatform" v-validate="'required'" label="platformName"
                :options="platformOptions" @input="setApplicationName" />
              <span class="text-danger">{{platformError}}</span>
            </div>
          </div>
        </form>
      </tab-content>

      <!-- tab 2 content -->
      <tab-content title="Package" class="mb-5" icon="feather icon-briefcase" :before-change="validateStep2">
        <form data-vv-scope="step-2">
          <div v-if="sec" class="p-2">
            <div class="vx-row">
              <vs-col vs-w="12">
                <h2 class="text-center mt-10 mb-10">Choose your package</h2>
              </vs-col>
            </div>
            <swiper :options="swiperOption" :dir="$vs.rtl ? 'rtl' : 'ltr'" :key="$vs.rtl" class="pb-8">
              <swiper-slide v-for="product in allProducts" :key="product.id"
                v-if="selectedPlatform != null && product.packagePlatform == selectedPlatform.platformCode">
                <div class="vx-col w-full mb-base">
                  <vx-card class="p-2">
                    <!-- <vs-avatar class="mx-auto mb-6 block" size="80px" src="card_4.userImg" /> -->
                    <div class="text-center">
                      <h4>{{product.packageType}}</h4>
                      <p class="text"><strong>{{product.count}}</strong> number/ {{product.periodYear}} year</p>
                      <p class="text"> + <strong class="">{{product.giftCount}} </strong> number as a Gift</p>
                    </div>
                    <vs-divider />
                    <div class="justify-between flex-wrap">
                      <p v-for="description in product.description.split(',')" :key="description" class="my-2">
                        {{description}}</p>
                    </div>
                    <h2 class="text-center">{{product.price}} {{product.currencySymbol}}</h2>
                    <template slot="footer">
                      <vs-divider />
                      <div class>
                        <span class="flex items-center">
                          <vs-button @click="setPackage(product)" class="mt-4 shadow-lg w-full" vs-w="12"
                            type="gradient" color="#7367F0" gradient-color-secondary="#CE9FFC">Select
                          </vs-button>
                        </span>
                      </div>
                    </template>
                  </vx-card>
                </div>
              </swiper-slide>

              <div class="swiper-pagination mt-5" slot="pagination"></div>
            </swiper>
            <span class="text-danger">{{selectedPackageNameError}}</span>
          </div>
        </form>
      </tab-content>

      <!-- tab 3 content -->
      <tab-content title="App Name" class="mb-5" icon="feather icon-at-sign" :before-change="validateStep3">
        <div class="vx-row">
          <vs-col vs-w="12">
            <h2 class="text-center mt-10 mb-10">Type your application name</h2>
          </vs-col>
        </div>
        <div class="lg:w-2/3 mx-auto">
          <form data-vv-scope="step-3">
            <vs-input disabled v-validate="{required:true ,min:3 , max:124 , regex:/^\S*$/}" data-vv-validate-on="blur"
              :label="selectedPlatform!= null && selectedPlatform.platformCode == '4' ?  'Android Application Name' : ''"
              name="appName" placeholder="Name" v-model="applicationName" class="w-full" />
            <span class="text-danger"> {{ errors.first('step-3.appName') }} </span>


            <div class="mt-3" v-if="selectedPlatform!= null && selectedPlatform.platformCode == '4'">
              <vs-input disabled v-validate="{required:true ,min:3 , max:124 , regex:/^\S*$/}" data-vv-validate-on="blur"
                name="secondAppName" placeholder="Name" label="IOS application name" v-model="secondApplicationName"
                class="w-full" />
              <span class="text-danger"> {{ errors.first('step-3.secondAppName') }} </span>
            </div>
          </form>
        </div>
      </tab-content>
      <!-- tab 4 content -->
      <tab-content title="Your Information" class="mb-5" icon="feather icon-file-text" :before-change="validateStep4">
        <div class="vx-row">
          <vs-col vs-w="12">
            <h2 class="text-center mt-10 mb-10">Enter your invoice information</h2>
            <p class="text-danger mb-3 text-center">{{invoiceDataError}}</p>
          </vs-col>
        </div>
        <form data-vv-scope="step-4">
          <div class="lg:w-2/3 mx-auto">
            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <vs-input class="w-full" label="Name & Surname" v-validate="'required'" data-vv-validate-on="blur"
                  type="tex" name="pan" placeholder="Enter your full name" :value="modelData.pan"
                  v-model="invoice.fullName" />

                <!-- Writing error message for validation -->
              </div>
            </div>
            <div class="vx-row mb-2 mt-5">
              <label class="vx-col w-full mb-2 vs-input--label">Country & Phone</label>
              <div class="vx-col w-full">
                <vue-tel-input :valid-characters-only="true" :defaultCountry="invoice.countryIso" :disabledFetchingCountry="true"
                  label="Phone and Country" name="phone" type="number" :inputOptions="temp" v-validate="'required'"
                  v-on:country-changed="countryChanged" class="w-full" v-model="invoice.phone"
                  :dynamicPlaceholder="false" :validCharactersOnly="true" :enabledCountryCode="false">
                </vue-tel-input>
              </div>
            </div>
            <div class="vx-row mt-5">
              <div class="vx-col w-full">
                <label class="vx-col w-full vs-input--label">Address</label>
                <vs-textarea label="Enter your full address" v-validate="'required'" v-model="invoice.address" />

              </div>
            </div>
            <div class="vx-row mt-5">
              <div class="vx-col w-full">
                <div class="vx-col w-full mb-2">Type</div>
                <vs-radio v-model="invoice.commercial" vs-name="commercial" v-validate="'required'" :vs-value="false">
                  Personal</vs-radio>
                <vs-radio class="ml-4" v-model="invoice.commercial" vs-name="commercial" :vs-value="true">Commercial
                </vs-radio>

              </div>
            </div>
            <div class="vx-row  mb-2" v-if="invoice.commercial">
              <div class="vx-col w-full">
                <vs-input class="w-full mt-5" label="Company Name" v-validate="'required'" data-vv-validate-on="blur" type="text" name="pan"
                  placeholder="Enter your company name" :value="invoice.companyName" v-model="invoice.companyName" />


                <vs-input class="w-full mt-5" label="Company Tax Number" v-validate="'required'" data-vv-validate-on="blur" type="text"
                  name="pan" placeholder="Enter your company tax number" :value="invoice.taxNo"
                  v-model="invoice.taxNo" />


                <vs-input class="w-full mt-5" label="Company Tax Department" v-validate="'required'" data-vv-validate-on="blur" type="text"
                  name="pan" placeholder="Enter your company tax department" :value="invoice.taxOffice"
                  v-model="invoice.taxOffice" />

              </div>
            </div>
          </div>


        </form>
      </tab-content>

      <!-- tab 5 content -->
      <tab-content title="Checkout" class="mb-5" icon="feather icon-shopping-bag" :before-change="validateStep5">

        <div class="vx-row my-5">
          <vs-col vs-w="8" class="mx-auto">
            <vs-table hoverFlat data="null">
              <!-- HEADER -->
              <template slot="thead">
                <vs-th class="pointer-events-none">PRODUCT NAME</vs-th>
                <vs-th class="pointer-events-none">LICENSE PLATFORM</vs-th>
                <vs-th class="pointer-events-none">COUNT</vs-th>
                <vs-th class="pointer-events-none">DURATION</vs-th>
              </template>

              <!-- DATA -->
          
                <vs-tr>
                  <vs-td>{{ selectedPackageName }}</vs-td>
                  <vs-td>{{ selectedPlatform.platformName }}</vs-td>
                  <vs-td>{{ selectedPackageCount }} + {{selectedPackageGiftCount}}</vs-td>
                  <vs-td>{{ selectedPackagePeriodMonth }} Month</vs-td>
                 

                </vs-tr>
              
            </vs-table>
            <span class="total">TOTAL:&nbsp; <span class="font-semibold"> {{selectedPackagePrice}} ({{selectedPackageCurrency}}) + 18% KDV = {{calculateKdvPrice(selectedPackagePrice)}} ({{selectedPackageCurrency}}) </span></span>
          </vs-col>
        </div>
        <vs-divider />

        <div v-if="selectedPackageType!='Free'" class="vx-row">
          <vs-col vs-w="12">
            <h2 class="text-center mt-10 mb-10">Select Payment method</h2>
            <p class="text-danger text-center"> {{paymentDataError}} </p>
          </vs-col>
        </div>


        <vs-tabs v-model="activeTab" v-if="(paymentType==0 || paymentType == 1) && selectedPackageType!='Free'" :value="paymentType" alignment="fixed">
          <vs-tab label="Credit Card">
            <div class="mt-5">

              <vs-col vs-w="12">

                <h5 class="text-left mt-10 mb-3">Enter your credit card detail</h5>
              </vs-col>

              <!-- <form data-vv-scope="step-5" action="https://entegrasyon.asseco-see.com.tr/fim/est3Dgate" method="post"> -->
              <form data-vv-scope="step-5" :action="authConfig.bankURL" method="post">

                <div class="vx-row mb-2">
                  <div class="vx-col w-full">
                    <vs-input class="w-full" v-validate="'required|min:16'" data-vv-validate-on="blur" type="number"
                      name="pan" label-placeholder="Card Number" :value="modelData.pan" v-model="modelData.pan" />
                  </div>
                </div>
                <div class="vx-row mb-2">
                  <div class="vx-col w-full">Expire Date</div>
                  
                  <div class="vx-col">
                    <vs-input class="w-full" v-validate="'required|min:2|max:2'" type="number" name="Ecom_Payment_Card_ExpDate_Month"
                      label-placeholder="Month"  :value="modelData.Ecom_Payment_Card_ExpDate_Month"
                      v-model="modelData.Ecom_Payment_Card_ExpDate_Month" />
                  </div>

                  <div class="vx-col">
                    <vs-input class="w-full"  v-validate="'required|min:2'" type="number" name="Ecom_Payment_Card_ExpDate_Year"
                      label-placeholder="Year" maxlength="2" :value="modelData.Ecom_Payment_Card_ExpDate_Year"
                      v-model="modelData.Ecom_Payment_Card_ExpDate_Year" />
                  </div>
                </div>
                <div class="vx-row mb-6">
                  <div class="vx-col w-full">
                    <vs-input class="w-full" v-validate="'required|min:3|max:3'" label-placeholder="Security Code" name="cv2" placeholder="Security Code"
                      :value="modelData.cv2" v-model="modelData.cv2" />
                  </div>
                </div>
                <div class="vx-row mb-2">
                  <div class="vx-col w-full">
                    <vs-checkbox disabled v-model="securePayment">3d Secure payment method. (only Available for Turkish Credit Cards) </vs-checkbox>

                  </div>
                </div>

                <input type="hidden" name="clientid" v-model="modelData.clientid" />
                <input type="hidden" name="amount" v-model="modelData.amount" />
                <input type="hidden" name="oid" v-model="modelData.oid" />
                <input type="hidden" name="okUrl" v-model="modelData.okUrl" />
                <input type="hidden" name="failUrl" v-model="modelData.failUrl" />
                <input type="hidden" name="rnd" v-model="modelData.rnd" />
                <input type="hidden" name="hash" v-model="modelData.hash" />
                <input type="hidden" name="callbackurl" value="" />
                <input type="hidden" name="callbackCall" value="false" />
                <input type="hidden" name="storetype" v-model="modelData.storetype" />
                <input type="hidden" name="lang" v-model="modelData.lang" />
                <input type="hidden" name="islemTipi" v-model="modelData.islemTipi" />
                <input type="hidden" name="currency" v-model="modelData.currency" />

                <button type="submit" v-show="false" id="pos-btn" value="submit">test post</button>
              </form>
            </div>
          </vs-tab>
          <vs-tab label="Bank Transfer">
            <div class="vx-row">

              <div class="vx-col lg:w-2/3 mt-10">
                <h5 class="text-left mb-3">Select your prefered bank</h5>
                <!-- <v-select data-vv-validate-on="blur" placeholder="Select one of the bank accounts" name="platform_name"
                  v-model="selectedBank" v-validate="'required'" label="Bank Name" :options="bankOptions" class="mb-5"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'" /> -->


                <form data-vv-scope="step-5">
                  <v-select v-model="selectedBank" name="bank.name" placeholder="Select one of the bank accounts"
                    v-validate="'required'" class="mb-5" data-vv-validate-on="blur" @input="changeBank"
                    :options="bankOptions.filter(x=> x.accountType === 2).filter(y => y.isActive == true)" label="bankText">
                    <template slot="option" slot-scope="option">
                      <div class="py-2 d-flex" >
                        <img height="20px" class="mr-2" :src="`${authConfig.uploadPath}${option.bank.imageUrl}`" />
                        <span> {{option.ibanNo}} - {{option.accountOwner}} - {{option.currency}} </span>
                      </div>
  
                    </template>
                  </v-select>
  
  
                  <span class="text-danger">{{platformError}}</span>
  
                  <vs-textarea label="Type a description for your Order" v-model="eftDescription" />
                  <span class="text-danger">{{platformError}}</span>
                </form>
              </div>

              <div class="vx-col lg:w-1/3 mt-10" style="min-height: 300px">
                <div  v-if="showTimeline">
                  <vx-card title="Don't Forget" noShadow>
                    <vx-timeline :data="timelineData"></vx-timeline>
                  </vx-card>
                </div>
              </div>

            </div>
          </vs-tab>

        </vs-tabs>


      </tab-content>
    </form-wizard>
  </vx-card>
</template>

<script>
import {
  FormWizard,
  TabContent
} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import vSelect from 'vue-select'
import invoice from './invoice'

// For custom error message
import {
  Validator
} from 'vee-validate'

import 'swiper/dist/css/swiper.min.css'
import {
  swiper,
  swiperSlide
} from 'vue-awesome-swiper'
import VxTimeline from '@/components/timeline/VxTimeline.vue'

import authConfig from '@/../auth_config.json'


// register custom messages
const dict = {
  custom: {
    appName: {
      required: 'Application name is required',
      min: 'This field must be at least 3 characters',
      regex: 'You can\'t use space in application name'
    },
    secondAppName: {
      required: 'Application name is required',
      min: 'This field must be at least 3 characters',
      regex: 'You can\'t use space in application name'
    }

  }
}

// register custom messages
Validator.localize('en', dict)


export default {
  components: {
    FormWizard,
    TabContent,
    swiper,
    swiperSlide,
    'v-select': vSelect,
    invoice,
    VxTimeline
  },
  created () {
    this.getOrder()
      
  },
  watch: {
    activeTab (val) {
      this.modelData.pan = '',
      this.modelData.Ecom_Payment_Card_ExpDate_Year = '',
      this.modelData.Ecom_Payment_Card_ExpDate_Month = '',
      this.modelData.cv2 = '',
      this.securePayment = true
    }

  },
  data () {
    return {
      order: '',
      authConfig,
      timelineData: [
        {
          color: 'primary',
          icon: 'PlusIcon',
          title: 'Company Name',
          desc: 'Sanalogi Bilisim San. ve Tic. A.S'
        },
        {
          color: 'warning',
          icon: 'AlertCircleIcon',
          title: 'Bank Information',
          desc: `Use the Swift Code: ${this.selectedBank && this.selectedBank.bank.swiftCode ? this.selectedBank.bank.swiftCode : ''}
             (out of Turkish banks) and IBAN:${this.selectedBank && this.selectedBank.bank.name ? this.selectedBank.bank.name : ''}.`
        },
        {
          color: 'success',
          icon: 'CheckIcon',
          title: 'EFT transaction',
          desc: 'You should definitely write your ORDER ID in the description section.',
          time: 'International money transfers can take up to 3 or 5 days'
        }
      ],
      bankOptions: [],
      selectedBank: '',
      eftDescription: '',
      activeTab: 0,
      modelData: {
        pan: '',
        cv2: '',
        Ecom_Payment_Card_ExpDate_Year: '',
        Ecom_Payment_Card_ExpDate_Month: '',
        cardType: null,
        clientid: null,
        islemtipi: 'Auth',
        amount: null,
        oid: null,
        okUrl: null,
        failUrl: null,
        rnd: null,
        hash: null,
        storetype: null,
        lang: 'tr',
        currency: 949
      },
      paymentType: null,
      cardNumber: '',
      cardMonth: '',
      cardYear: '',
      cardPass: '',
      cardType: '',
      securePayment: true,
      value: '',
      value2: '',
      applicationName: '',
      secondApplicationName: null,
      selected: {
        packageName: ''
      },
      selectedPackageNameError:'',
      selectedPackageName: '',
      selectedPackageID: '',
      selectedPackagePrice: '',
      selectedPackagePeriodMonth: '',
      selectedPackageCurrency: '',
      selectedPackageCount:'',
      selectedPackageType:'',
      selectedPackageGiftCount:'',
      allProducts: [],
      sec: '',
      platformError: '',
      applicationNameError: '',
      secondApplicationNameError: '',
      invoiceDataError: '',
      paymentDataError: '',
      selectedPlatform: '',
      showTimeline: false,
      package: '',
      name: '',
      platformOptions: [
        {
          platformName: 'Android',
          platformCode: '1'
        },
        {
          platformName: 'IOS',
          platformCode: '2'
        },
        {
          platformName: 'Both Android & IOS',
          platformCode: '4'
        }
      ],

      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 30,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        breakpoints: {
          1024: {
            slidesPerView: 3,
            spaceBetween: 40
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 30
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 20
          }
        }
      },
      invoice: {
        fullName: '',
        phone: '',
        country: '',
        countryCode: '',
        countryIso: '',
        address: '',
        commercial: '',
        companyName: null,
        taxNo: null,
        taxOffice: null
      },
      temp: {
        showDialCode: true,
        tabindex: 0
      }
    }
  },
  methods: {
    calculateKdvPrice (value) {
      const price = (value * 18) / 100
      return value + price
    },
    setApplicationName (val) {
      if (val.platformCode == 1) {
        this.applicationName = this.order.orderItems.filter(order => order.liciencePlatform == 'Android')[0].applicationName
      } else if (val.platformCode == 2) {
        this.applicationName = this.order.orderItems.filter(order => order.liciencePlatform == 'IOS')[0].applicationName
      } else if (val.platformCode == 4) {
        this.applicationName = this.order.orderItems.filter(order => order.liciencePlatform == 'Android')[0].applicationName
        this.secondApplicationName = this.order.orderItems.filter(order => order.liciencePlatform == 'IOS')[0].applicationName
      }

       
      // Andoid and ios application name
           
      // if(response.data.orderItems.filter(order => order.liciencePlatform == 'Android').length){
      //   this.applicationName = response.data.orderItems.filter(order => order.liciencePlatform == 'Android')[0].applicationName
      // }
      // if(response.data.orderItems.filter(order => order.liciencePlatform == 'IOS').length){
      //   this.selectedPlatform.platformCode == 1 ? this.applicationName = response.data.orderItems.filter(order => order.liciencePlatform == 'IOS')[0].applicationName : 
      //                                   this.secondApplicationName = response.data.orderItems.filter(order => order.liciencePlatform == 'IOS')[0].applicationName
      // }


    },
    changeBank () {
        
      this.timelineData[1].desc = `Use the Swift Code: ${this.selectedBank.bank.swiftCode} (out of Turkish banks) and IBAN:${this.selectedBank.ibanNo}.`
      this.showTimeline = true
    },
    countryChanged (country) {
      this.invoice.countryCode = country.dialCode
      this.invoice.country = country.name
    },
    fuseSearch (options, search) {
      const a = []
      options.forEach((element) => {
        if (
          element.platformName.startsWith(search) ||
            element.platformName.startsWith(search.toUpperCase())
        ) a.push(element)
      })
      return a
    },

    getOrder () {
      this.$vs.loading()
      this.$store.dispatch('order/getOrder', this.$route.params.orderId)
        .then((response) => {
          this.$vs.loading.close()
          this.order = response.data

          // Set the platform in first step
          if (response.data.orderItems.length == 1) {
            this.selectedPlatform = this.platformOptions.filter(platform => platform.platformName == response.data.orderItems[0].liciencePlatform)[0]
          } else {
            this.selectedPlatform = this.platformOptions[2]
          }
          this.setApplicationName(this.selectedPlatform)
          this.getProducts()

            
        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },

    getProducts () {
      this.$store
        .dispatch('product/getProducts')
        .then((response) => {
          this.allProducts = response.data
        })
        .catch((error) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },
    setPackage (product) {
      this.selectedPackageName = product.name
      this.selectedPackageID = product.id
      this.selectedPackagePrice = product.price
      this.selectedPackageCount = product.count
      this.selectedPackagePeriodMonth = product.periodMonth
      this.selectedPackageCurrency = product.currency
      this.selectedPackageType = product.packageType
      this.selectedPackageGiftCount = product.giftCount

      this.$refs.checkoutWizard.nextTab()
    },
    validateStep1 () {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll('step-1').then((result) => {
          if (result) {
            this.platformError = ''
            resolve(true)
            this.sec = true
          } else {
            this.platformError = 'You must choose your platform'
            reject('correct all values')
          }
        })
      })
    },
    validateStep2 () {
      if (this.selectedPackageName) {
        this.selectedPackageNameError = ''
        return true
      } else {
        this.selectedPackageNameError = 'You must choose one of the above packages'
        return false
      }

    },
    // Application Namevalidation
    validateStep3 () {
      return new Promise((resolve, reject) => {


        this.$validator.validateAll('step-3').then((result) => {
          if (result) {


            this.$store.dispatch('license/getLastInvoiceData')
              .then((response) => {
                this.invoice.fullName = response.data.fullName
                this.invoice.countryIso = response.data.countryIso
                this.invoice.phone = response.data.phone
                this.invoice.address = response.data.address
                this.invoice.commercial = response.data.isCorporate
                this.invoice.companyName = response.data.companyName
                this.invoice.taxNo = response.data.taxNo
                this.invoice.taxOffice = response.data.taxOffice
                resolve(true)
                return true
              })
              .catch(error => {
                this.$vs.loading.close()
                this.$vs.notify({
                  title: 'Error',
                  text: error.message,
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'danger'
                })
              })

          } else {


            reject('correct all values')
          }
        })
      })
    },
    // Invoice Form
    validateStep4 () {

      if (this.paymentType == null) this.paymentType = 0


      return new Promise((resolve, reject) => {


        this.$validator.validateAll('step-4').then((result) => {
          if (result) {
            this.invoiceDataError = ''


            this.$store.dispatch('bank/getAllAccounts')
              .then((response) => {
                this.bankOptions = response.data
                // const temp = []
                // response.data.forEach(element => {
                //   temp.push(`<img src=""> ${element.bankName} ${element.ibanNo}`)
                // });
                // this.bankOptions = temp
                resolve(true)
              })
              .catch(error => {
                this.$vs.loading.close()
                this.$vs.notify({
                  title: 'Error',
                  text: error.message,
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'danger'
                })
              })
            resolve(true)

          } else {

            this.invoiceDataError = 'please fill all of the neccessary fields'
            reject('correct all values')
          }
        })
      })


    },
    // Bank card validation
    validateStep5 () {
        
      const payload = {
        ApplicationName: this.applicationName,
        SecondApplicationName: this.secondApplicationName,
        platform: this.selectedPlatform.platformCode,
        packageId: this.selectedPackageID,
        isSecure: this.securePayment,
        paymentType: parseInt(this.activeTab) + 1,
        fullName: this.invoice.fullName,
        country: this.invoice.country,
        phone: this.invoice.phone,
        companyName: this.invoice.companyName,
        taxNo: this.invoice.taxNo,
        taxOffice: this.invoice.taxOffice,
        address: this.invoice.address,
        accountId: this.selectedBank.id,
        description: this.eftDescription,

        // Just for check in action
        isCommercial: this.invoice.commercial
      }
      // this.$vs.loading()

      return new Promise((resolve, reject) => {
        this.$validator.validateAll('step-5').then((result) => {
            
          if (result) {
            this.$vs.loading()
            this.paymentDataError = ''
            resolve(true)
            this.$store
              .dispatch('product/extendProduct', payload)
              .then((response) => {
                this.$vs.loading.close()
                if (response.data.result) {
                  // Set Values

                  this.modelData.amount = response.data.data.amount
                  this.modelData.oid = response.data.data.oid
                  this.modelData.currency = response.data.data.currency
                  this.modelData.failUrl = response.data.data.failUrl
                  this.modelData.okUrl = response.data.data.okUrl
                  this.modelData.rnd = response.data.data.rnd
                  this.modelData.hash = response.data.data.hash
                  this.modelData.islemTipi = response.data.data.islemTipi
                  this.modelData.clientid = response.data.data.shopCode
                  this.modelData.storetype = response.data.data.storetype
                  this.modelData.storeKey = response.data.data.storeKey
                  //


                  // if it's a free package then we are going to send it liciences list page
                  if (response.data.data.free) {
                    setTimeout(() => this.$router.push(`/orders/${response.data.data.orderId}`), 4000)
                    this.$vs.notify({
                      time: 4000,
                      title: response.data.message,
                      text: 'We are redirecting you to products page',
                      iconPack: 'feather',
                      icon: 'icon-alert-circle',
                      color: 'success'
                    })
                  } else if (response.data.data.isEFT) {
                    setTimeout(() => this.$router.push(`/orders/${response.data.data.orderId}`), 4000)
                    this.$vs.notify({
                      time: 4000,
                      title: response.data.message,
                      text: 'Your SDK generated. Please wait unit approved',
                      iconPack: 'feather',
                      icon: 'icon-alert-circle',
                      color: 'success'
                    })
                  } else {
                    // Else post bank we are redirecting payment screen
                    this.$vs.loading.close()
                    this.$vs.notify({
                      text: 'Congratulations.We are redirecting you payment secreen',
                      iconPack: 'feather',
                      icon: 'icon-alert-circle',
                      color: 'success'
                    })

                    const button = document.getElementById('pos-btn')

                    setTimeout(() => {
                      button.click()
                    }, 3000)

                  }
                } else {
                  this.$vs.loading.close()
                  this.$vs.notify({
                    time: 4000,
                    title: 'Error',
                    text: response.data.message,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                  })
                }
              })
              .catch((error) => {
                this.$vs.loading.close()
                this.$vs.notify({
                  time: 4000,
                  title: 'Error',
                  text: error.message,
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'danger'
                })
              })

              
          } else {
            this.paymentDataError = 'Please Fill all of the neccessary fields.'
            reject('correct all values')
          }
        })
      })
    }
  }
}
</script>